import { commonLang } from '@umu/ukit-lang';
/*
 * @file alert类型的Dialog
 * @example
 *
 *      alert({
            className: 'demo',
            title: 'title',
            content: 'content',
            btnConfirmText: 'btnConfirmText',
            submitBtnClick: () => {
                console.log('submitBtnClick')
            },

        });
 *
 */

import { Dialog, DialogBody, DialogFooter, DialogFooterButton, DialogHeader, IDialogProps } from '../dialog/dialog';
import React, { Component } from 'react';
import If from '../if';
import modalServiceWrapper, { IWrapperConfig } from './modalServiceWrapper';

export interface IAlertDialogProps extends IWrapperConfig, IDialogProps {
    showDialog?: boolean; // 是否显示弹窗
    hasMask?: boolean; // 是否显示遮罩层
    className?: string; // 自定义类名
    showClose?: boolean; // 是否显示右上角的关闭按钮
    title: string; // 标题
    content: string | JSX.Element; // 内容
    btnCancleText?: string; // 确定按钮文案
    btnConfirmText?: string; // 确定按钮文案
    submitBtnClick?: () => void; // 确认按钮回调
    close?: () => void; // 关闭弹窗
    afterClose?: () => void;
    cancelBtnClick?: () => void;
}

class AlertDialog extends Component<IAlertDialogProps> {
    public static defaultProps = {
        showDialog: true,
        hasMask: true,
        className: '',
        showClose: false,
        title: '',
        content: '',
        btnConfirmText: commonLang('确认'),
    };

    constructor(props: IAlertDialogProps) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    public componentDidUpdate() {
        const { showDialog, afterClose } = this.props;
        if (!showDialog && afterClose) {
            afterClose();
        }
    }

    public onCancel() {
        const { cancelBtnClick, close } = this.props;
        if (cancelBtnClick) {
            cancelBtnClick();
        }
        if (close) {
            close();
        }
    }

    public onSubmit() {
        const { submitBtnClick, close } = this.props;
        if (submitBtnClick) {
            submitBtnClick();
        }
        if (close) {
            close();
        }
    }

    public render() {
        const {
            close,
            showDialog,
            hasMask,
            className,
            showClose,
            title,
            content,
            btnConfirmText,
            width,
            btnCancleText,
        } = this.props;

        return (
            <div className="dialog-alert">
                <Dialog
                    show={!!showDialog}
                    hasMask={hasMask}
                    className={`modal-dialog ${className}`}
                    canClose={showClose}
                    close={close}
                    width={width}
                >
                    <DialogHeader>
                        <div className="title">{title}</div>
                    </DialogHeader>
                    <DialogBody>
                        <div className="info">{content}</div>
                    </DialogBody>
                    <DialogFooter>
                        <If condition={!!btnCancleText}>
                            <DialogFooterButton onClick={this.onCancel}>{btnCancleText}</DialogFooterButton>
                        </If>
                        <DialogFooterButton onClick={this.onSubmit}>{btnConfirmText}</DialogFooterButton>
                    </DialogFooter>
                </Dialog>
            </div>
        );
    }
}

export default modalServiceWrapper(AlertDialog);
